/* 图书折扣信息组件 */
<template>
  <div class="flexRow InnerPriceContainer" v-if="$attrs.book">
    <div class="flexRowS" v-if="$attrs.book && $attrs.book.tDiscount">
      <template v-if="$attrs.book.tDiscount.discountType == '0'">
        <template v-if="showPrice">
          <span
            v-if="$attrs.buyCar"
            class="bookPrice mr10"
            :class="{ bookPriceFade: $attrs.colorreset }"
          >
            <span class="priceSymbol">¥</span>
            {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
          </span>
          <span v-else class="bookPrice mr10" :class="{ bookPriceFade: $attrs.colorreset }">
            <span class="priceSymbol">¥</span>
            <span>
              {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
            </span>
          </span>
        </template>
        <template v-if="showLinePrice">
          <span class="linePrice">
            ¥
            <span class="lineThrough">
              {{ $attrs.book.price || $attrs.book.BookPrice | priceFormat }}
            </span>
          </span>
        </template>
        <template v-if="showSpike">
          <span class="ml10 flexRow youhui">
            限时优惠{{ accMul($attrs.book.tDiscount.discountRatio, 10) }}折
          </span>
        </template>
      </template>
      <template v-if="$attrs.book.tDiscount.discountType == '1'">
        <template v-if="$attrs.book.tDiscount.spikePrice * 1 === 0">
          <div class="flexRowS">
            <span class="freeToDate">
              限时免费至{{ $attrs.book.tDiscount.endDate.substr(0, 10) }}
            </span>
          </div>
        </template>
        <template v-else>
          <template v-if="showPrice">
            <span
              v-if="$attrs.buyCar"
              class="bookPrice"
              :class="{ bookPriceFade: $attrs.colorreset }"
            >
              <span class="priceSymbol">¥</span>

              {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
            </span>
            <span v-else class="bookPrice" :class="{ bookPriceFade: $attrs.colorreset }">
              <span class="priceSymbol">¥</span>
              {{ $attrs.book.tDiscount.spikePrice | priceFormat }}
            </span>
          </template>
          <template v-if="showLinePrice">
            <span class="linePrice ml10">
              ¥
              <span class="lineThrough">
                {{ $attrs.book.price || $attrs.book.BookPrice | priceFormat }}
              </span>
            </span>
          </template>
          <template v-if="showSpike">
            <span class="ml20 flexRow youhui">秒杀</span>
          </template>
        </template>
      </template>
    </div>
    <span
      class="bookPrice"
      style="text-decoration: none"
      v-else
      :class="{ bookPriceFade: $attrs.colorreset }"
    >
      <template v-if="showPrice">
        <span class="priceSymbol">¥</span>
        {{ $attrs.book.BookPrice || $attrs.book.price | priceFormat }}
      </template>
    </span>
  </div>
</template>

<script lang="ts">
import { accMul } from "@/utils/index"
export default {
  name: "PopItem",
  props: {
    showPrice: {
      type: Boolean,
      default: true,
    },
    showSpike: {
      type: Boolean,
      default: true,
    },
    showLinePrice: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    accMul(a, b) {
      if (!a || !b) {
        return 0
      }
      return accMul(a, b)
    },
  },
}
</script>
<style lang="less" scoped>
.InnerPriceContainer {
  align-items: flex-end;
  justify-content: flex-start;
}
.bookPrice {
  font-size: 18px;
  color: #fa5151;
}
.bookPriceFade {
  color: #a1a9b0;
}
.killPrice {
  // height: 40px;
  border-radius: 3px;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #088190;
}

.freeToDate {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #088190;
}

.youhui {
  background: #fcdbdb;
  border-radius: 3px;
  line-height: 28px;
  font-size: 14px;
  color: #fa5151;
  padding: 0 16px;
}
.priceSymbol {
  font-size: 14px;
  color: #fa5151;
}
.linePrice {
  font-size: 14px;
  color: #b7bec5;
}
.lineThrough {
  text-decoration: line-through;
}
</style>
